module.exports = __webpack_public_path__ + "media/City of Pales, Nurua.b45e8a88.mp3";